import { string } from "prop-types";

export class RedirectKeySubmit {
  key: string | null | undefined;
  url: string | null | undefined;
}
